import { Component } from "@angular/core";
import { SearchBoxDlgDelegate } from "../../../common";

@Component({
  selector: "container-search-box",
  templateUrl: "./container-search-box.html",
  standalone: false,
  inputs: ["searchCriteria"],
  outputs: ["searchCriteriaChanged"],
})
export class ContainerSearchBox extends SearchBoxDlgDelegate {}
